import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { compact, uniqBy } from 'lodash'

import { Select as SelectComponent } from 'components'

const GovernanceProjectTemplateSelect = ({
  control,
  errors,
  eligibleTemplates = [],
  loading = false,
  error = null,
  savedTemplate = null,
}) => {
  // o template já salvo entra nas opções para o valor selecionado casar com a lista
  const items = uniqBy(compact([...eligibleTemplates, savedTemplate]), 'id')

  return (
    <Controller
      as={
        <SelectComponent
          label="Projeto de governança (template)"
          items={items}
          loading={loading}
          error={!!error || !!errors?.governanceProjectTemplateId}
          helperText={
            (error && 'Não foi possível carregar os templates.') ||
            errors?.governanceProjectTemplateId?.message
          }
        />
      }
      name="governanceProjectTemplateId"
      control={control}
    />
  )
}

GovernanceProjectTemplateSelect.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  eligibleTemplates: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.object,
  savedTemplate: PropTypes.object,
}

export default GovernanceProjectTemplateSelect
